import {Action} from './common.js';

const KEY_VIDEO = 'VIDEO';
const KEY_VIDEO_PLAY = 'PLAY';

export default class VideoAction extends Action {

    get type() {return KEY_VIDEO;}

    init() {
        if (document.body && document.body.addEventListener) {
            document.body.addEventListener('externalPlayerVideoMessage', (e) => {
                if(e.detail) this._doVideoAction(e);
            }, false);
        }
    }

    _doVideoAction(e) {
        // do not track timeupdate or when there are no action (other events)
        if (!e.detail || !e.detail.action || e.detail.action === 'timeupdate') {
            return;
        }

        this._details = {
            id: e.detail.id,
            media_type: e.detail.mediatype,
            action: e.detail.action.toUpperCase(),
            total_time: e.detail.totalTime || '',
            current_time: e.detail.currentTime || ''
        };

        if (e.detail.action === 'seeking') {
            this._details.seek_to = e.detail.seekTo || '';
        }

        super.sendAction();
    }
}
